import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, style, transition, animate} from '@angular/animations';
import { SessionDataService } from 'src/app/services/session-data/session-data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SessionData } from 'src/app/domain/session-data';

@Component({
  selector: 'app-faq-home-page-component',
  templateUrl: './faq-home-page.component.html',
  styleUrls: ['./faq-home-page.component.scss'],
  animations: [
    trigger('showDivFaq', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1.5s', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('1.5s', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class FaqHomePageComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  sessionData: SessionData;

  constructor(private sessionDataService: SessionDataService) { }

  ngOnInit() {
    this.sessionDataService.getSessionData().pipe(takeUntil(this.unsubscribe)).subscribe(
      (sessionData: SessionData) => {
        this.sessionData = sessionData;
        this.sessionData.strongAuthSms = true;
      }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
